export const ENTRYPOINT = process.env.VUE_APP_API_URL;
export const MEDIA_SERVER = process.env.VUE_APP_MEDIA_SERVER;
